import { t } from '../i18n/pt-BR'

/**
 * As telas que nao sao o mundo: carregando, recusa e falha (modo_historia/03#HM-002). DOM simples, com texto
 * do dicionario (docs/08 secao 10).
 *
 * **A recusa nao diz o motivo** (docs/21 secao 2): flag desligada e conta fora da lista sao a mesma tela.
 */

const card = (title: string, body: string): HTMLElement => {
  const screen = document.createElement('main')
  screen.className = 'screen'
  const box = document.createElement('div')
  box.className = 'screen-card'
  const h1 = document.createElement('h1')
  h1.textContent = title
  const p = document.createElement('p')
  p.textContent = body
  box.append(h1, p)
  screen.append(box)
  return screen
}

export function backToGameLink(web2Url: string): HTMLAnchorElement {
  const link = document.createElement('a')
  link.className = 'button'
  link.href = `${web2Url}/`
  link.textContent = t.backToGame
  return link
}

export function loadingScreen(): HTMLElement {
  const screen = document.createElement('main')
  screen.className = 'screen'
  screen.setAttribute('aria-busy', 'true')
  screen.textContent = t.loading
  return screen
}

export function deniedScreen(web2Url: string): HTMLElement {
  const screen = card(t.denied.title, t.denied.body)
  screen.querySelector('.screen-card')?.append(backToGameLink(web2Url))
  return screen
}

export function failedScreen(onRetry: () => void): HTMLElement {
  const screen = card(t.failed.title, t.failed.body)
  const retry = document.createElement('button')
  retry.type = 'button'
  retry.className = 'button'
  retry.textContent = t.failed.retry
  retry.addEventListener('click', onRetry)
  screen.querySelector('.screen-card')?.append(retry)
  return screen
}

export function show(root: HTMLElement, screen: HTMLElement): void {
  root.replaceChildren(screen)
}

/** A entrada recusada pela exclusividade, com o motivo traduzido e a volta ao jogo. */
export function refusedScreen(web2Url: string, code: string): HTMLElement {
  const reasons = t.refused.reason as Record<string, string>
  const screen = card(t.refused.title, reasons[code] ?? t.refused.reason.OTHER)
  screen.querySelector('.screen-card')?.append(backToGameLink(web2Url))
  return screen
}
